import * as yup from "yup";
import { requiredKanaAlpNum } from "../utility/ValidationUtilty";
import { ConstMessage } from "../config/const";

export type Groups = {
  id: string;
  name: string;
  nameKana: string;
  explanation: string;
  userCount: number;
  adminCount: number;
  createAt: Date;
  updateAt: Date;
  groupColor: string;
  deleteFlg: boolean;
}

export const newGroup: Groups =  {
  id: "",
  name: "",
  nameKana: "",
  explanation: "",
  userCount: 0,
  adminCount: 0,
  createAt: new Date(),
  updateAt: new Date(),
  groupColor: "",
  deleteFlg: false,
};

export type GroupsUsers = {
  documentID: string;
  joinedAt: Date;
}

export type GroupCollection = {
  group: Groups;
  groupUsers: GroupsUsers[];
}

export const groupSchema = yup.object({
  name: yup.string().required(),
  nameKana: requiredKanaAlpNum,
})

/**
 * DBの取得結果を GroupData 型に変換
 * @param data 
 * @returns 
 */
export const GroupItemMapingFromDb = (data: any | undefined): Groups | Groups => {
  data.createAt = new Date(data?.createAt);

  data.updateAt = data?.updateAt !== null
    ? new Date(data?.updateAt) : undefined;

  return data;
}